import React, { useState } from 'react';
import { Switch } from '@cokitchen/cokitchen-components';
import { DeleteIcon, EditAltIcon } from 'cokitchen-icons';
import { getSimpleDateFormat } from 'utils/functions';
import { NoticeDataType } from '.';
import { ENUM_NOTICE_STATUS } from 'utils/enum';
import NoticeBoardModal from 'components/cs/pending-tasks/notice-board';
import DeleteNoticeModal from 'components/kitchen/modals/delete-notice-modal';

export type selectedNotice = {
  name: string;
  id: string;
};

const NoticeCardFooter = ({ data }: { data: NoticeDataType }) => {
  const { created_at, status, title, id } = data;

  const [showNoticeModal, setShowNoticeModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState({} as NoticeDataType);

  const handleEdit = (data: NoticeDataType) => {
    setShowNoticeModal(true);
    setSelectedNotice(data);
  };

  const toggleNoticeBoards = () => {
    setShowNoticeModal(!showNoticeModal);
  };

  return (
    <div>
      <div className='flex justify-between ml-[18px] items-center border-t-[0.7px] border-[#EAEBEB] py-4'>
        <p className='text-sm'>Active {getSimpleDateFormat(created_at)}</p>
        <div className='flex gap-2 mr-[18px]'>
          {status !== ENUM_NOTICE_STATUS.DRAFT && (
            <Switch active={status === ENUM_NOTICE_STATUS.ACTIVE} />
          )}
          <div
            onClick={() => handleEdit(data)}
            className='p-1 w-fit cursor-pointer rounded-full border-[0.7px] border-[#EAEBEB]'>
            <EditAltIcon />
          </div>
          <div className='p-1 cursor-pointer w-fit rounded-full border-[0.7px] border-[#EAEBEB]'>
            <DeleteIcon onClick={() => setOpenDeleteModal(true)} />
          </div>
        </div>
      </div>

      <DeleteNoticeModal
        show={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        title={title}
        id={id}
      />

      <NoticeBoardModal
        type='edit'
        show={showNoticeModal}
        onClose={toggleNoticeBoards}
        notice={selectedNotice}
      />
    </div>
  );
};

export default NoticeCardFooter;
